import { render } from "./ProjetGeltram.vue?vue&type=template&id=acee98ae&scoped=true"
import script from "./ProjetGeltram.vue?vue&type=script&lang=js"
export * from "./ProjetGeltram.vue?vue&type=script&lang=js"

import "./ProjetGeltram.vue?vue&type=style&index=0&id=acee98ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acee98ae"]])

export default __exports__